import HowToQualifyVaroAdvance from 'features/advance/screens/manageAdvanceAccount/HowToQualifyVaroAdvance/HowToQualifyVaroAdvance';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function HowToQualifyVaroAdvancePage() {
  return (
    <PinwheelContextProvider>
      <HowToQualifyVaroAdvance />
    </PinwheelContextProvider>
  );
}
